<div class="delete-transport-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'delete transport' | translate: ['tmc.visit.overview.cancel-transport-dialog.title',
      translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="top-info">
      <app-transport-info-panel [carrier]="data.carrier" [identifier]="data.identifier" [driver]="data.name"
        [scope]="data.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">
      <div class="flex-container-column">
        <div>
          <app-dictionary-key-select (selectionChanged)="optionsChanged($event)"
            placeholder="{{'select cause' | translate: ['tmc.visit.overview.cancel-transport-dialog.causeTitle', translationService.language]}}"
            [rootKey]="'lookup.deletion-cause.options'" [required]="true" [selectedIndex]="selectedIndex">
          </app-dictionary-key-select>
        </div>
        <div class="flex-grow">
          <mat-form-field class="textarea-remark">
            <textarea appearance="fill"
              placeholder="{{'remark' | translate: ['tmc.visit.overview.cancel-transport-dialog.remark', translationService.language]}}"
              matInput [(ngModel)]="remark" [maxlength]="9999"
              [required]="cps.isRequired('visitoverview.delete.length.cause', false)" cdkTextareaAutosize
              cdkAutosizeMinRows="8" cdkAutosizeMaxRows="8"></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div>
      <div class="messages">
        <app-service-response [responseMessages]="responseMessages"></app-service-response>
      </div>

      <i class="horizontal-divider"></i>

      <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button class="cancel-button" (click)="cancelDialog()"
          [disabled]="isCancelDisabled()">{{'cancel' | translate:['shared.selection-dialog.action.cancel',
          translationService.language]}}</button>
          <sc-content-spacer ></sc-content-spacer>
          <button mat-flat-button (click)="confirm()" class="confirm-button"
          [disabled]="isConfirmDisabled()">{{'confirm' |
          translate:['tmc.visit.overview.cancel-transport-dialog.button.confirm',
          translationService.language]}}</button>
      </sc-actionbar>

    </div>
  </div>
</div>